import { render } from "./coach-tabset.vue?vue&type=template&id=709dc0ae"
import script from "./coach-tabset.vue?vue&type=script&lang=js"
export * from "./coach-tabset.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__